import {
  COMPARE_SET_DATA,
  COMPARE_SET_FILTER,
  COMPARE_SET_GAME_COMPARE,
  COMPARE_SET_GAME_NUMBER,
  COMPARE_SET_LOADING,
  COMPARE_SET_1V1_DATA,
  COMPARE_SET_1V1_DATA_ERROR,
  COMPARE_SET_1V1_FILTER,
  COMPARE_MULTI_RANGE_SET_FILTER,
  COMPARE_SET_MULTI_DATA,
  COMPARE_SET_MULTI_DATA_ERROR,
  COMPARE_SET_CHARTS
} from "../actions/compare.actions";

import { INITIALIZE_STORE } from "../actions/manager.actions";

const initialState = {
  filter: {
    dates: new Array(5).fill(null),
    position: undefined,
    playerGroup: undefined
  },
  filter_1v1: {
    startDate: null,
    endDate: null,
    selectionLeft: [],
    selectionRight: [],
    selectedMetrics: []
  },
  filter_multi_range: {
    dateRangeMap: {},
    playerCardSelections: [],
    selectedMetrics: []
  },
  loading: false,
  data: { metrics: [], data: [] },
  gameNumber: 4,
  gameCompare: true,
  data_1v1: {},
  data_multi_range: {},
  comparisonCharts: []
};

export const compareReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPARE_SET_CHARTS:
      return { ...state, comparisonCharts: action.payload };
    case COMPARE_SET_FILTER:
      return { ...state, filter: { ...state.filter, ...action.payload } };
    case COMPARE_SET_1V1_FILTER:
      return { ...state, filter_1v1: { ...state.filter_1v1, ...action.payload } };
    case COMPARE_MULTI_RANGE_SET_FILTER:
      if ('dateRangeMap' in action.payload)
        return  { ...state, 
                  filter_multi_range: { ...state.filter_multi_range, 
                                      dateRangeMap: {...state.filter_multi_range.dateRangeMap, ...action.payload.dateRangeMap} 
                                    } 
                };
      
      return { ...state, filter_multi_range: { ...state.filter_multi_range, ...action.payload } };
    case COMPARE_SET_LOADING:
      return { ...state, loading: action.payload };
    case COMPARE_SET_DATA:
      return { ...state, data: action.payload };
    case COMPARE_SET_1V1_DATA:
      return { ...state, data_1v1: action.payload };
    case COMPARE_SET_1V1_DATA_ERROR:
      return { ...state, error: action.payload };
    case COMPARE_SET_MULTI_DATA:
      return { ...state, data_multi_range: action.payload };
    case COMPARE_SET_MULTI_DATA_ERROR:
      return { ...state, error: action.payload };
    case COMPARE_SET_GAME_NUMBER:
      return { ...state, gameNumber: action.payload };
    case COMPARE_SET_GAME_COMPARE:
      return { ...state, gameCompare: action.payload };
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
